import React, { useState, useEffect, useRef, useCallback } from "react";

import { SearchProvider } from "../../../contexts/SearchContext";
import ClientsInfoAgent from "../../../Components/Agent/ClientsInfoAgent/clientsinfoagent";
import PriceOfferComponent from "../../../Components/Agent/PriceOfferComponent/priceoffercomponent";

// CSS
import "./priceoffer.css";
import { Loader } from "../../../Components/Loader/Loader";
import { redirect, useParams } from "react-router-dom";

const PriceOffer = () => {
  // Checkers
  const { dynamicOrderId } = useParams();
  const [isDone, setIsDone] = useState(false);
  const [loading, setLodaing] = useState(true);
  const prevPathRef = useRef(window.location.pathname + window.location.search);

  const _setIsDone = (newIsDone) => {
    setIsDone(newIsDone);
    setLodaing(false);
  };
  // const isDone = false;

  // Save info between components
  const [clientsinfo, setClientsinfo] = useState({
    name: "",
    email: "",
    phone: "",
    fullAddress: "",
    address: "",
    city: "",
    country: "",
    zipCode: "",
    fullname: "44",
  });

  // --- UseEffects
  useEffect(() => {
    // Add an event listener to the 'beforeunload' event
    window.addEventListener("load", handleRefresh);

    return () => {
      // Clean up by removing the event listener when the component is unmounted
      window.removeEventListener("load", handleRefresh);
    };
  }, []);

  useEffect(() => {
    if (localStorage.getItem("agent-saved-client-info") || dynamicOrderId) {
      _setIsDone(true);
    } else {
      setLodaing(false);
    }
  }, []);

  // Check if current client details were deleted,
  // if so return to clientsinfo component
  useEffect(() => {
    const saveClient = "agent-saved-client-info";

    // Event listener function
    const storageChangeHandler = (event) => {
      if (event.key === saveClient && event.newValue === null) {
        _setIsDone(false);
      }
    };

    // Add the event listener
    window.addEventListener("storage", storageChangeHandler);
  }, []);

  // --- Functions
  const handleRefresh = (event) => {
    // Before the window is refreshed delete all session storage
    sessionStorage.clear();

    event.preventDefault();
    event.returnValue = ""; // Needed for Chrome and legacy browsers
  };

  // --- Actions
  const changeClient = () => {
    _setIsDone(false);
  };

  const handleLocationChange = useCallback(() => {
    if (!isDone) return;

    // Check current path
    const currentPath = window.location.pathname;

    // Get URL parameters
    const params = new URLSearchParams(window.location.search);
    const clearuser = params.get("clearuser");

    if (clearuser) {
      changeClient();
      // go to the base url without parameters dont reload
      window.location.href = currentPath;
    }
  }, [isDone]);

  // navigation to searchoffer with a changeclient Directive changes the client
  useEffect(() => {
    // Run once on initial effect execution if done
    if (isDone) {
      handleLocationChange();
    }

    // Function to check for location changes
    const checkForLocationChange = () => {
      const newPath = window.location.pathname + window.location.search;
      if (prevPathRef.current !== newPath) {
        prevPathRef.current = newPath;
        handleLocationChange();
      }
    };

    // Handle popstate events (back/forward buttons)
    const handlePopState = () => {
      checkForLocationChange();
    };

    // Intercept history methods to catch programmatic changes
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function () {
      originalPushState.apply(this, arguments);
      checkForLocationChange();
    };

    window.history.replaceState = function () {
      originalReplaceState.apply(this, arguments);
      checkForLocationChange();
    };

    // Set up event listeners
    window.addEventListener("popstate", handlePopState);

    // Clean up
    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []); // Re-run when isDone or handleLocationChange changes

  const renderComponent = () => {
    if (isDone) {
      return (
        <PriceOfferComponent
          clientsInfoParam={clientsinfo}
          changeClient={changeClient}
        />
      );
    }
    return (
      <ClientsInfoAgent
        clientsInfo={setClientsinfo}
        finishAction={_setIsDone}
      />
    );
  };

  return (
    <>
      <div className="priceOffer-wrapper">
        {/* Components */}
        <div className="priceOffer-component-wrapper">
          {loading ? <Loader /> : renderComponent()}
        </div>
      </div>
    </>
  );
};

export default PriceOffer;
